import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@mui/material";
import React from "react";
import { selectIsInitialized } from "#/features/project/model/projectSlice";
import { useAppSelector } from "#/store/hooks";
export const LoadingSkeletonOverlay: React.FC = () => {
  const $ = _c(1);
  const isInitialized = useAppSelector(selectIsInitialized);
  if (isInitialized) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton animation="wave" variant="rectangular" sx={{
      position: "absolute",
      background: "#0000",
      animation: "pulse 2s infinite ease-in-out",
      height: "100%",
      width: "100%",
      borderRadius: 2,
      top: 0,
      left: 0,
      zIndex: 10,
      cursor: "wait",
      "@keyframes pulse": {
        "0%": {
          background: "#fff0"
        },
        "50%": {
          background: "#fff1"
        },
        "100%": {
          background: "#fff0"
        }
      }
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};